import React, { ChangeEventHandler, FC, useCallback } from 'react';

import './Toggle.scss';

interface IProps {
    currentValue: boolean,
    setter: (value: boolean) => void
}

const Toggle: FC<IProps> = (props) => {
    const { currentValue, setter, children } = props

    const onChange: ChangeEventHandler<HTMLInputElement> = useCallback((event) => {
        setter(event.target.checked)
    }, [setter])

    return <label className='switch'>
        <input type="checkbox" onChange={onChange} checked={currentValue} />
        <span>{children}</span>
    </label>
}

export default Toggle;